/* Earth N Essence: mini cart helpers.
   1) shows prices with the rupee symbol (display only; the store's currency setting is unchanged)
   2) keeps Checkout visibly locked, with a message, until the terms box is ticked */
(function () {
  function fixText(s) {
    return s.replace(/Rs\.?\s?([\d,]+)\.00/g, '\u20B9$1').replace(/Rs\.?\s?/g, '\u20B9').replace(/\s+INR\b/g, '');
  }
  function fix(n) {
    if (n.nodeType === 3) {
      if (/Rs\./.test(n.nodeValue) || /\sINR\b/.test(n.nodeValue)) n.nodeValue = fixText(n.nodeValue);
    } else if (n.nodeType === 1) {
      n.childNodes.forEach(fix);
    }
  }
  function lockSync(root) {
    var cb = root.querySelector('#cart_agree');
    var btn = root.querySelector('.bee-btn__checkout');
    if (!cb || !btn) return;
    var locked = !cb.checked;
    btn.classList.toggle('is-locked', locked);
    btn.setAttribute('aria-disabled', locked ? 'true' : 'false');
    var agree = cb.closest('.bee-cart__agree');
    var msg = root.querySelector('.ene-lock-msg');
    if (!msg && agree) {
      msg = document.createElement('p');
      msg.className = 'ene-lock-msg';
      msg.setAttribute('role', 'status');
      msg.textContent = 'Tick the box above to unlock checkout.';
      agree.insertAdjacentElement('afterend', msg);
    }
    if (msg) msg.hidden = !locked;
  }
  var queued = false;
  function run() {
    queued = false;
    var root = document.getElementById('bee-mini_cart');
    if (!root) return;
    fix(root);
    lockSync(root);
  }
  function schedule() { if (!queued) { queued = true; setTimeout(run, 0); } }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'cart_agree') schedule();
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#bee-mini_cart .bee-btn__checkout');
    if (b && b.classList.contains('is-locked')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var msg = document.querySelector('#bee-mini_cart .ene-lock-msg');
      if (msg) { msg.classList.remove('nudge'); void msg.offsetWidth; msg.classList.add('nudge'); }
    }
  }, true);
  function start() {
    run();
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if ((t && t.nodeType === 1 && (t.id === 'bee-mini_cart' || (t.closest && t.closest('#bee-mini_cart')))) || list[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
